module.exports = __webpack_public_path__ + "img/bg.caee88dd.jpg";